import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
 batch, shallowEqual, useDispatch, useSelector
} from 'react-redux';

import Breadcrumbs from '../../../../layout/components/Breadcrumbs';
import Button from '../../../../components/Button/Button';
import ButtonTypes from '../../../../constants/buttonTypes';
import { IconFileExport, IconSetting } from '../../../../assets/icon';
import TableSettingModal from '../../../../components/TableSettingModal/TableSettingModal';
import { setApplicationState } from '../../../../actions/application/application';
import toggleArrayItem from '../../../../helpers/toggleArrayItem';
import DownloadFileModal from '../../../../components/DownloadFileModal/DownloadFileModal';
import downloadFilesType from '../../../../constants/downloadFilesType';
import { coAcceptanceTable } from '../../../../constants/coAcceptanceTable';
import SearchInput from '../../../../components/SearchInput/SearchInput';
import getAcceptanceDelays from '../../../../thunks/coilovers/acceptance/getAcceptanceDelays';
import getAcceptanceToDay from '../../../../thunks/coilovers/acceptance/getAcceptanceToDay';
import getAcceptanceIssues from '../../../../thunks/coilovers/acceptance/getAcceptanceIssues';

const subheaderClassName = 'flex items-center border-t border-[#eff2f5] dark:border-[#1b263b] px-[25px] h-full';
const breadcrumbsClassName = 'py-[5px]';
const searchContainerClassName = 'ml-[20px] w-full max-w-[400px]';
const searchInputClassName = 'py-[10px]';
const buttonClassName = 'px-[13px] py-[8px] mr-[5px]';

const AcceptanceSubheader = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [downloadModalVisible, setDownloadModalVisible] = useState(false);
  const [tableSettingModalVisible, setTableSettingModalVisible] = useState(false);
  const [query, setQuery] = useState('');
  const [timer, setTimer] = useState();

  useEffect(() => {
    clearTimeout(timer);
    const t = setTimeout(() => batch(() => {
      dispatch(getAcceptanceDelays({ query }));
      dispatch(getAcceptanceToDay({ query }));
      dispatch(getAcceptanceIssues({ query }));
    }), 800);
    setTimer(t);
  }, [query]);

  const {
    application: { coAcceptanceTableSetting },
  } = useSelector((state) => ({
    application: state?.application,
  }), shallowEqual);

  const breadcrumbs = {
    pageTitle: 'Acceptance',
    history: [
      {
        title: 'Home',
        onClick: () => navigate('/')
      },
      {
        title: 'Coilovers',
      },
      {
        title: 'Acceptance',
      },
    ]
  };

  return (
    <div className={subheaderClassName}>
      <div className="flex-1">
        <div className="flex flex-row items-center">
          <Breadcrumbs breadcrumbs={breadcrumbs} containerStyle={breadcrumbsClassName} />
          <div className="flex flex-1 justify-center">
            <div className={searchContainerClassName}>
              <SearchInput
                styleInput={searchInputClassName}
                onChange={({ target: { value } }) => setQuery(value)}
                value={query}
                autoFocus
                isClearable
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-row justify-end">
        <Button
          type={ButtonTypes.LIGHT}
          icon={<IconFileExport />}
          containerStyle={buttonClassName}
          tooltip="Coming soon"
          tooltipId="acceptanceExportTable"
          disabled
        />
        <Button
          type={ButtonTypes.LIGHT}
          icon={<IconSetting />}
          containerStyle={buttonClassName}
          tooltip="Table settings"
          tooltipId="acceptanceTableSettings"
          onClick={() => setTableSettingModalVisible(true)}
        />
      </div>
      <TableSettingModal
        title="Acceptance Table Setting"
        visible={tableSettingModalVisible}
        toggleVisible={() => setTableSettingModalVisible(false)}
        list={coAcceptanceTable}
        values={coAcceptanceTableSetting}
        onSelect={(val) => dispatch(setApplicationState({
          coAcceptanceTableSetting: toggleArrayItem(coAcceptanceTableSetting, val)
        }))}
      />
      <DownloadFileModal
        visible={downloadModalVisible}
        toggleVisible={() => setDownloadModalVisible(false)}
        type={downloadFilesType.ORDERED_PARTS}
      />
    </div>
  );
};

AcceptanceSubheader.propTypes = {};

AcceptanceSubheader.defaultProps = {};

export default AcceptanceSubheader;
